(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valino-email-popup"]) return;
  try {
    
(function () {
  'use strict';

  /* ============================================================
     CONFIG
     ============================================================ */
  var SK_DISMISSED  = 'vp2_dismissed';
  var SK_SUBSCRIBED = 'vp2_subscribed';
  var SK_TIMER      = 'vp2_timer_end';
  var DISMISS_MS    = 14 * 24 * 60 * 60 * 1000;
  var SUBSCRIBE_MS  = 90 * 24 * 60 * 60 * 1000;
  var OFFER_SECS    = 15 * 60;
  var DELAY_MS      = 5000;
  var SCROLL_PCT    = 40;
  var IDLE_MS       = 22000;
  var URGENT_SECS   = 120;

  /* ============================================================
     STORAGE
     ============================================================ */
  function lsGet(k) {
    try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; }
  }
  function lsSet(k, v) {
    try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {}
  }
  function ssGet(k) {
    try { return JSON.parse(sessionStorage.getItem(k)); } catch (e) { return null; }
  }
  function ssSet(k, v) {
    try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {}
  }
  function isDismissed() {
    var d = lsGet(SK_DISMISSED);
    return d && d.ts && (Date.now() - d.ts) < DISMISS_MS;
  }
  function isSubscribed() {
    var s = lsGet(SK_SUBSCRIBED);
    return s && s.ts && (Date.now() - s.ts) < SUBSCRIBE_MS;
  }
  function setDismissed() { lsSet(SK_DISMISSED, { ts: Date.now() }); }
  function setSubscribed() { lsSet(SK_SUBSCRIBED, { ts: Date.now() }); setDismissed(); }

  /* ============================================================
     PAGE EXCLUSIONS
     ============================================================ */
  function shouldSkip() {
    var p = window.location.pathname;
    var ex = ['/cart', '/checkout', '/account', '/login', '/register', '/password', '/orders'];
    for (var i = 0; i < ex.length; i++) {
      if (p.indexOf(ex[i]) === 0) return true;
    }
    return false;
  }

  /* ============================================================
     DOM HELPERS
     ============================================================ */
  function g(id) { return document.getElementById(id); }

  /* ============================================================
     POPUP STATE
     ============================================================ */
  var shown        = false;
  var timerTick    = null;
  var interest     = '';
  var lastFocused  = null;

  function trapFocus(e) {
    if (!shown || e.key !== 'Tab') return;
    var modal = g('vpop');
    if (!modal) return;
    var focusable = modal.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    var visible = [];
    for (var i = 0; i < focusable.length; i++) {
      if (focusable[i].offsetParent !== null) visible.push(focusable[i]);
    }
    if (!visible.length) return;
    var first = visible[0], last = visible[visible.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus({ preventScroll: true });
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus({ preventScroll: true });
    }
  }

  function openPopup() {
    if (shown) return;
    shown = true;
    lastFocused = document.activeElement;
    var ov = g('vpop-overlay');
    var m  = g('vpop');
    if (!ov || !m) return;
    ov.classList.add('vpop-on');
    m.classList.add('vpop-on');
    startCountdown();
    document.addEventListener('keydown', trapFocus);
    /* Intentionally NOT auto-focusing the close button. Even with
       preventScroll, the focus call has been observed to cause +17000px
       scroll jumps on production. The popup is visually clear and
       dismissible via X or Escape — programmatic focus is not required. */
  }

  function closePopup(dismiss) {
    var ov = g('vpop-overlay');
    var m  = g('vpop');
    if (!ov || !m) return;
    ov.classList.remove('vpop-on');
    m.classList.remove('vpop-on');
    clearInterval(timerTick);
    document.removeEventListener('keydown', trapFocus);
    shown = false;
    /* Do NOT restore focus to lastFocused on close. Could scroll page if
       the previously-focused element is below current scroll position. */
    lastFocused = null;
    if (dismiss !== false) setDismissed();
  }

  /* ============================================================
     COUNTDOWN TIMER
     ============================================================ */
  function getSecsLeft() {
    var saved = ssGet(SK_TIMER);
    var now = Date.now();
    if (saved && saved.end > now) return Math.floor((saved.end - now) / 1000);
    var end = now + (OFFER_SECS * 1000);
    ssSet(SK_TIMER, { end: end });
    return OFFER_SECS;
  }

  function startCountdown() {
    var el = g('vpop-clock');
    if (!el) return;
    function tick() {
      if (document.hidden) return;
      var s = getSecsLeft();
      if (s <= 0) { el.textContent = '00:00'; clearInterval(timerTick); return; }
      var m = Math.floor(s / 60), sec = s % 60;
      el.textContent = (m < 10 ? '0' : '') + m + ':' + (sec < 10 ? '0' : '') + sec;
      if (s <= URGENT_SECS) {
        el.classList.add('vpop-urgent');
      } else {
        el.classList.remove('vpop-urgent');
      }
    }
    tick();
    timerTick = setInterval(tick, 1000);
  }

  /* ============================================================
     STEPS
     ============================================================ */
  function showStep(n) {
    var steps = document.querySelectorAll('.vpop-step');
    for (var i = 0; i < steps.length; i++) {
      steps[i].classList.add('vp-hide');
    }
    var t = g('vpop-s' + n);
    if (t) t.classList.remove('vp-hide');
    if (n === 2) {
      requestAnimationFrame(function () {
        var e = g('vpop-email');
        if (e) e.focus({ preventScroll: true });
      });
    }
  }

  /* ============================================================
     PERSONALISATION COPY
     ============================================================ */
  var COPY = {
    women: { title: 'Your 10% off is waiting!',   sub: 'Enter your email for an exclusive women\'s fashion discount.' },
    men:   { title: 'Your 10% off is ready!',      sub: 'Enter your email for an exclusive men\'s fashion discount.' },
    all:   { title: 'Your 10% off is locked in!',  sub: 'Enter your email and unlock your personal welcome discount.' }
  };
  function pickInterest(val) {
    interest = val;
    var c = COPY[val] || COPY.all;
    var t = g('vpop-s2-title'), s = g('vpop-s2-sub'), f = g('vpop-interest-field');
    if (t) t.textContent = c.title;
    if (s) s.textContent = c.sub;
    if (f) f.value = 'Interest: ' + val;
    showStep(2);
  }

  /* ============================================================
     SMART TRIGGERS
     ============================================================ */
  var fired = false;
  var timerH, idleH;

  function trigger() {
    if (fired || isDismissed() || isSubscribed()) return;
    fired = true;
    clearTimeout(timerH);
    clearTimeout(idleH);
    openPopup();
  }

  function resetIdle() {
    clearTimeout(idleH);
    if (!fired) idleH = setTimeout(trigger, IDLE_MS);
  }

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    if (isDismissed() || isSubscribed() || shouldSkip()) return;

    /* ---- Wire close handlers ---- */
    var closeBtn     = g('vpop-close');
    var noThanksBtn  = g('vpop-nothanks');
    var overlay      = g('vpop-overlay');
    var backBtn      = g('vpop-back');
    var form         = g('vpop-form');
    var copyBtn      = g('vpop-copy');
    var closeSuccess = g('vpop-close-success');

    function onDismiss() { closePopup(); }

    if (closeBtn)    closeBtn.addEventListener('click', onDismiss);
    if (overlay)     overlay.addEventListener('click', onDismiss);
    if (noThanksBtn) {
      noThanksBtn.addEventListener('click', onDismiss);
      noThanksBtn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') onDismiss();
      });
    }
    if (closeSuccess) {
      closeSuccess.addEventListener('click', function () { closePopup(false); });
      closeSuccess.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') closePopup(false);
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') onDismiss();
    });

    /* ---- Interest buttons ---- */
    var intBtns = document.querySelectorAll('.vpop-int');
    for (var i = 0; i < intBtns.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          pickInterest(btn.getAttribute('data-interest'));
        });
      })(intBtns[i]);
    }

    /* ---- Back button ---- */
    if (backBtn) {
      backBtn.addEventListener('click', function () { showStep(1); });
      backBtn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') showStep(1);
      });
    }

    /* ---- Form submit ---- */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailEl  = g('vpop-email');
        var submitEl = g('vpop-submit');
        var statusEl = g('vpop-form-status');
        if (!emailEl || !emailEl.value) return;
        if (statusEl) statusEl.textContent = '';

        if (submitEl) { submitEl.disabled = true; submitEl.textContent = 'Processing\u2026'; }

        var fd = new FormData(form);
        fetch(form.action || '/contact', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        }).then(function () {
          setSubscribed();
          clearInterval(timerTick);
          showStep(3);
        }).catch(function () {
          if (submitEl) { submitEl.disabled = false; submitEl.textContent = 'Try Again'; }
          if (statusEl) statusEl.textContent = 'Network error. Please try again.';
        });
      });
    }

    /* ---- Copy code ---- */
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = 'WELCOME10';
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).catch(function () {});
        } else {
          try {
            var ta = document.createElement('textarea');
            ta.value = code;
            ta.style.cssText = 'position:fixed;top:-9999px';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
          } catch (err) {}
        }
        copyBtn.textContent = 'COPIED!';
        copyBtn.classList.add('vpop-copied');
        setTimeout(function () {
          copyBtn.textContent = 'COPY';
          copyBtn.classList.remove('vpop-copied');
        }, 2800);
      });
    }

    /* ---- Trigger 1: Time delay ---- */
    timerH = setTimeout(trigger, DELAY_MS);

    /* ---- Trigger 2: Exit intent (desktop) ---- */
    document.addEventListener('mouseleave', function (e) {
      if (e.clientY <= 4 && !fired) {
        clearTimeout(timerH);
        trigger();
      }
    });

    /* ---- Trigger 3: Scroll depth via IntersectionObserver sentinel ---- */
    if ('IntersectionObserver' in window) {
      var sentinel = document.createElement('div');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'position:absolute;left:0;width:1px;height:1px;pointer-events:none;';
      function placeSentinel() {
        var docH = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
        sentinel.style.top = Math.floor(docH * (SCROLL_PCT / 100)) + 'px';
      }
      placeSentinel();
      document.body.appendChild(sentinel);
      var sIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !fired) {
            clearTimeout(timerH);
            sIO.disconnect();
            trigger();
          }
        });
      });
      sIO.observe(sentinel);
      window.addEventListener('resize', placeSentinel, { passive: true });
    }

    /* ---- Trigger 4: Idle detection ---- */
    idleH = setTimeout(trigger, IDLE_MS);
    var idleEvents = ['mousemove', 'keydown', 'touchstart', 'click', 'scroll'];
    for (var j = 0; j < idleEvents.length; j++) {
      document.addEventListener(idleEvents[j], resetIdle, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valino-hero-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  var roots = document.querySelectorAll('[data-vhs-edit]');
  if (!roots.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-inview');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  roots.forEach(function (r) { io.observe(r); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valino-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll("[data-vhero]").forEach(function(hero){
    var track=hero.querySelector(".vhero__track");
    var slides=hero.querySelectorAll(".vhero__slide");
    var dots=hero.querySelectorAll(".vhero__dot");
    var prev=hero.querySelector(".vhero__arrow--prev");
    var next=hero.querySelector(".vhero__arrow--next");
    var total=slides.length;
    var cur=0;
    var timer;
    if(total<=1)return;
    function go(i){
      slides[cur].classList.remove("vhero__slide--active");
      if(dots[cur]){dots[cur].classList.remove("vhero__dot--active");dots[cur].setAttribute("aria-selected","false");}
      cur=(i+total)%total;
      track.style.transform="translateX(-"+(cur*100)+"%)";
      slides[cur].classList.add("vhero__slide--active");
      if(dots[cur]){dots[cur].classList.add("vhero__dot--active");dots[cur].setAttribute("aria-selected","true");}
    }
    function start(){timer=setInterval(function(){go(cur+1)},5200);}
    function stop(){clearInterval(timer);}
    if(next){next.addEventListener("click",function(){stop();go(cur+1);start();});}
    if(prev){prev.addEventListener("click",function(){stop();go(cur-1);start();});}
    dots.forEach(function(d){d.addEventListener("click",function(){stop();go(parseInt(d.dataset.index));start();});});
    hero.addEventListener("mouseenter",stop);
    hero.addEventListener("mouseleave",start);
    var tx=0;
    hero.addEventListener("touchstart",function(e){tx=e.touches[0].clientX;stop();},{passive:true});
    hero.addEventListener("touchend",function(e){var d=tx-e.changedTouches[0].clientX;if(Math.abs(d)>50){if(d>0){go(cur+1);}else{go(cur-1);}}start();},{passive:true});
    start();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valino-homepage-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* Timing is phase-locked so an image change can never be amputated by a
     slide change. Within a 7000ms slide the left column changes at 2600 and
     5200 (settled by 6000) and the right at 4600 (settled by 5400); the next
     tick of either would fall past the boundary, where the panel is already
     stopped. SLIDE_FADE must match the .vmh__slide.is-active transition and
     the progress bar's 7s sweep must match SLIDE_INTERVAL. */
  var SLIDE_INTERVAL = 7000;
  var SLIDE_FADE     = 680;
  var IMG_INTERVAL   = 2600;
  var RIGHT_DELAY    = 2000;
  var MEM_KEY        = 'valino:hero:v1';
  var MEM_TTL_DAYS   = 21;

  var hero = document.querySelector('[data-vmh]');
  if (!hero) return;

  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ── Which products this shopper has already been shown ──
     Same envelope and 21-day TTL as the product rails (valino:rails:v1) but
     deliberately its own key: the rails remember page numbers, this remembers
     product ids, and one key holding both shapes would corrupt whichever
     reader got there second. */
  var Memory = {
    _cache: null,

    load: function () {
      if (this._cache) return this._cache;
      var data = {};
      try {
        var raw = window.localStorage.getItem(MEM_KEY);
        if (raw) {
          var parsed = JSON.parse(raw);
          var age = (Date.now() - (parsed.ts || 0)) / 86400000;
          if (age < MEM_TTL_DAYS && parsed.panels) data = parsed.panels;
        }
      } catch (e) { /* private mode or storage disabled — rotate without memory */ }
      this._cache = data;
      return data;
    },

    seen: function (key) { return this.load()[key] || []; },

    remember: function (key, pid) {
      if (!pid) return;
      var d = this.load();
      var list = d[key] || [];
      if (list.indexOf(pid) !== -1) return;
      list.push(pid);
      d[key] = list;
      this.save(d);
    },

    reset: function (key) {
      var d = this.load();
      delete d[key];
      this.save(d);
    },

    save: function (d) {
      try {
        window.localStorage.setItem(MEM_KEY, JSON.stringify({ ts: Date.now(), panels: d }));
      } catch (e) { /* quota reached — the in-memory copy still steers this visit */ }
    }
  };

  /* ── One image column ──
     Only the first two layers arrive as real <img>. The rest are empty divs
     carrying data-src, promoted on demand, so a deep pool costs a URL in the
     HTML instead of a download before first paint. */
  function ImagePanel(col, isLcp) {
    this.col    = col;
    this.key    = col.getAttribute('data-vmh-key') || 'vmh';
    this.layers = Array.prototype.slice.call(col.querySelectorAll('.vmh__img-slide'));
    this.total  = this.layers.length;
    this.isLcp  = !!isLcp;
    this.timer   = null;
    this.startTo = null;

    this.cur = 0;
    for (var i = 0; i < this.total; i++) {
      if (this.layers[i].classList.contains('is-active')) { this.cur = i; break; }
    }

    this.order = this.buildOrder();
    this.pos = this.order.indexOf(this.cur);
    if (this.pos === -1) this.pos = 0;
    this.markSeen(this.cur);
  }

  /* Unseen product first, in the order Shopify returned it, and only then
     anything already shown. */
  ImagePanel.prototype.buildOrder = function () {
    var seen = Memory.seen(this.key);
    var fresh = [];
    var stale = [];
    for (var i = 0; i < this.total; i++) {
      var pid = this.layers[i].getAttribute('data-vmh-pid');
      if (pid && seen.indexOf(pid) !== -1) stale.push(i);
      else fresh.push(i);
    }
    if (!fresh.length) {
      /* The whole pool has been seen. Start it over rather than freezing on
         pictures this shopper already knows. */
      Memory.reset(this.key);
      return stale;
    }
    return fresh.concat(stale);
  };

  ImagePanel.prototype.markSeen = function (i) {
    var el = this.layers[i];
    if (el) Memory.remember(this.key, el.getAttribute('data-vmh-pid'));
  };

  ImagePanel.prototype.ensureImage = function (i) {
    var el = this.layers[i];
    if (!el) return Promise.resolve();
    var src = el.getAttribute('data-src');
    if (!src) return Promise.resolve();

    el.removeAttribute('data-src');
    var img = document.createElement('img');
    img.className = 'vmh__img';
    img.width = 900;
    img.height = 700;
    img.decoding = 'async';
    img.alt = el.getAttribute('data-alt') || '';
    var srcset = el.getAttribute('data-srcset');
    if (srcset) {
      img.setAttribute('srcset', srcset);
      img.setAttribute('sizes', '(min-width: 750px) 38vw, 100vw');
    }
    img.src = src;
    el.appendChild(img);

    if (img.decode) return img.decode().catch(function () {});
    return new Promise(function (resolve) {
      img.addEventListener('load', resolve, { once: true });
      img.addEventListener('error', resolve, { once: true });
    });
  };

  /* Decode the next picture while the current one is still on screen so a
     fade never waits on the network. */
  ImagePanel.prototype.warmNext = function () {
    if (this.order.length < 2) return;
    this.ensureImage(this.order[(this.pos + 1) % this.order.length]);
  };

  ImagePanel.prototype.activate = function (i, instant) {
    var self = this;
    if (i === this.cur || !this.layers[i]) return;
    this.ensureImage(i).then(function () {
      if (self.cur === i) return;
      var el = self.layers[i];
      if (instant) el.style.transition = 'none';
      self.layers[self.cur].classList.remove('is-active');
      self.cur = i;
      el.classList.add('is-active');
      if (instant) {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () { el.style.transition = ''; });
        });
      }
      self.markSeen(i);
      self.warmNext();
    });
  };

  ImagePanel.prototype.prime = function () {
    /* The first slide's left image is the largest-contentful paint. Leave it
       exactly as the server sent it — swapping it here would mean fetching a
       second image before LCP — and let it rotate normally a beat later. */
    if (this.isLcp || !this.order.length) return;
    if (this.order[0] === this.cur) return;
    this.pos = 0;
    this.activate(this.order[0], true);
  };

  ImagePanel.prototype.advance = function () {
    if (this.order.length < 2) return;
    this.pos = (this.pos + 1) % this.order.length;
    this.activate(this.order[this.pos], false);
  };

  ImagePanel.prototype.start = function (delay) {
    if (this.order.length < 2 || this.timer || this.startTo) return;
    var self = this;
    if (delay) {
      this.startTo = window.setTimeout(function () {
        self.startTo = null;
        self.timer = window.setInterval(function () { self.advance(); }, IMG_INTERVAL);
      }, delay);
    } else {
      this.timer = window.setInterval(function () { self.advance(); }, IMG_INTERVAL);
    }
  };

  /* Stop, but deliberately do NOT rewind. The old code reset the panel to its
     first image the instant the slide began leaving, so the picture on screen
     snapped backwards mid-transition. Holding position also means a slide
     resumes where it left off instead of replaying its opening image. */
  ImagePanel.prototype.stop = function () {
    window.clearTimeout(this.startTo);
    this.startTo = null;
    window.clearInterval(this.timer);
    this.timer = null;
  };

  /* ── Main carousel ── */
  var slides  = Array.prototype.slice.call(hero.querySelectorAll('.vmh__slide'));
  var dots    = Array.prototype.slice.call(hero.querySelectorAll('.vmh__dot'));
  var prog    = hero.querySelector('[data-vmh-progress]');
  var prevBtn = hero.querySelector('.vmh__arrow--prev');
  var nextBtn = hero.querySelector('.vmh__arrow--next');
  var toggle  = hero.querySelector('.vmh__toggle');

  var userPaused = motion.matches;
  var hovered = false;
  var focused = false;
  var total = slides.length;
  if (!total) return;
  var cur = 0;
  var timer = null;
  var leaveTimer = null;

  slides.forEach(function (slide, si) {
    var cols = Array.prototype.slice.call(slide.querySelectorAll('[data-vmh-img-panel]'));
    slide._imgPanels = cols.map(function (col, ci) {
      return new ImagePanel(col, si === 0 && ci === 0);
    });
  });

  slides.forEach(function (slide) {
    (slide._imgPanels || []).forEach(function (ip) { ip.prime(); });
  });

  function canPlay() { return !userPaused && !hovered && !focused && !document.hidden; }

  function startImgPanels(slide) {
    if (!canPlay()) return;
    (slide._imgPanels || []).forEach(function (ip, idx) {
      ip.start(idx * RIGHT_DELAY); /* left column leads, right column trails */
    });
  }

  function stopImgPanels(slide) {
    (slide._imgPanels || []).forEach(function (ip) { ip.stop(); });
  }

  /* Sweep every slide back into a state consistent with what is actually on
     screen. Driven off current classes rather than a captured reference, so a
     burst of arrow clicks inside the dissolve window cannot strand a slide as
     inert-but-visible or leave one held in the leaving state. */
  function settleSlides() {
    slides.forEach(function (s) {
      var active = s.classList.contains('is-active');
      if (!active) s.classList.remove('is-leaving');
      s.inert = !active;
      s.setAttribute('aria-hidden', String(!active));
    });
  }

  function goTo(i) {
    var next = ((i % total) + total) % total;
    if (next === cur) return;

    var outgoing = slides[cur];
    var incoming = slides[next];

    stopImgPanels(outgoing);
    outgoing.classList.remove('is-active');
    outgoing.classList.add('is-leaving');
    if (dots[cur]) { dots[cur].classList.remove('is-active'); dots[cur].setAttribute('aria-pressed', 'false'); }

    cur = next;

    incoming.classList.remove('is-leaving');
    incoming.classList.add('is-active');
    incoming.inert = false;
    incoming.setAttribute('aria-hidden', 'false');
    if (dots[cur]) { dots[cur].classList.add('is-active'); dots[cur].setAttribute('aria-pressed', 'true'); }

    /* The outgoing slide stays opaque underneath, and stays reachable, until
       the incoming one has finished covering it. */
    window.clearTimeout(leaveTimer);
    leaveTimer = window.setTimeout(settleSlides, SLIDE_FADE + 80);

    startImgPanels(incoming);

    if (prog) {
      prog.classList.remove('is-running');
      void prog.offsetWidth;
      if (timer) prog.classList.add('is-running');
    }
  }

  function start() {
    if (timer || !canPlay()) return;
    startImgPanels(slides[cur]);
    if (total < 2) return;
    if (prog) { prog.classList.remove('is-running'); void prog.offsetWidth; prog.classList.add('is-running'); }
    timer = window.setInterval(function () { goTo(cur + 1); }, SLIDE_INTERVAL);
  }

  function pause() {
    slides.forEach(function (slide) { stopImgPanels(slide); });
    window.clearInterval(timer);
    timer = null;
    if (prog) prog.classList.remove('is-running');
  }

  function restart() { pause(); start(); }

  if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); goTo(cur - 1); restart(); });
  if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); goTo(cur + 1); restart(); });

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () { goTo(parseInt(dot.getAttribute('data-index'), 10)); restart(); });
  });

  function updateToggle() {
    if (!toggle) return;
    toggle.textContent = userPaused ? 'Play' : 'Pause';
    toggle.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
    toggle.setAttribute('aria-pressed', String(userPaused));
  }
  if (toggle) toggle.addEventListener('click', function () {
    userPaused = !userPaused;
    updateToggle();
    userPaused ? pause() : start();
  });

  hero.addEventListener('mouseenter', function () { hovered = true; pause(); });
  hero.addEventListener('mouseleave', function () { hovered = false; start(); });
  hero.addEventListener('focusin', function () { focused = true; pause(); });
  hero.addEventListener('focusout', function (event) {
    if (!hero.contains(event.relatedTarget)) { focused = false; start(); }
  });
  document.addEventListener('visibilitychange', function () { document.hidden ? pause() : start(); });
  motion.addEventListener('change', function (event) {
    if (event.matches) {
      userPaused = true;
      pause();
      updateToggle();
      hero.classList.remove('vmh--parallax', 'vmh--pointing');
    }
  });

  settleSlides();
  updateToggle();

  var tx = 0;
  hero.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
  hero.addEventListener('touchend', function (e) {
    var d = tx - e.changedTouches[0].clientX;
    if (Math.abs(d) > 44) { d > 0 ? goTo(cur + 1) : goTo(cur - 1); restart(); }
  }, { passive: true });

  /* ── Pointer parallax ──
     Fine-pointer devices only. The hero already pauses on hover, so this is a
     deliberate "I am looking at this" moment. Layers move through custom
     properties, which the stylesheet applies as `translate`/`scale` individual
     properties — compositor-only, and composed with rather than overwriting
     the transform-based entrance. The rect is cached on enter and resize:
     reading it inside the move handler would thrash layout at 60Hz. */
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !motion.matches) {
    hero.classList.add('vmh--parallax');
    var raf = null;
    var rect = null;
    var px = 0;
    var py = 0;

    hero.addEventListener('mouseenter', function () {
      rect = hero.getBoundingClientRect();
      hero.classList.add('vmh--pointing');
    });

    window.addEventListener('resize', function () {
      rect = hero.classList.contains('vmh--pointing') ? hero.getBoundingClientRect() : null;
    }, { passive: true });

    hero.addEventListener('mousemove', function (e) {
      if (!rect) rect = hero.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      px = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
      py = ((e.clientY - rect.top) / rect.height - 0.5) * 2;
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = null;
        hero.style.setProperty('--vmh-px', px.toFixed(3));
        hero.style.setProperty('--vmh-py', py.toFixed(3));
      });
    }, { passive: true });

    hero.addEventListener('mouseleave', function () {
      hero.classList.remove('vmh--pointing');
      hero.style.setProperty('--vmh-px', '0');
      hero.style.setProperty('--vmh-py', '0');
    });
  }

  startImgPanels(slides[cur]);
  if (total > 1) start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valino-mega-nav"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Desktop breakpoint at which CSS hides the drawer/overlay/hamburger and
     shows the horizontal nav (see the matching @media rule above). Kept as
     one constant so the JS cleanup below can never drift from the CSS. */
  var DESKTOP_MQ = '(min-width: 1366px)';
  var LOCK_NAME = 'mega-nav-drawer';

  var ham, dr, ov, drx, vmnRoot, vmnBar;
  var isOpen = false;
  var lastFocused = null;
  var lockedEls = [];
  var bound = false;

  function isVisible(el) {
    if (!el || typeof el.focus !== 'function') return false;
    if (el === document.body || el === document.documentElement) return false;
    if (el.hasAttribute('inert') || (el.closest && el.closest('[inert]'))) return false;
    if (!el.getClientRects().length) return false;
    var cs = window.getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none';
  }

  /* ── background inert while the drawer is open ──
     `inert` removes the rest of the page from the tab order and from
     hit-testing in one step (native focus-containment + "not accidentally
     interactive"). Only the drawer/overlay (both inside #vmn) stay
     interactive. This alone does not make Tab wrap at the drawer's own
     first/last focusable element (a Tab past the last one simply leaves the
     document, since nothing else is focusable) — handleDrawerTab() below
     adds that explicit wrap so forward/reverse Tab stays inside the dialog.

     Walk from #vmn up to <body>, inerting every SIBLING along the way —
     not the whole ancestor branch containing #vmn. A section sharing an
     ancestor wrapper with #vmn (e.g. another header-group section) must
     become noninteractive too, not be skipped just because it shares that
     wrapper. Elements that already carry `inert` from some other feature
     (another open dialog) are left untouched in both directions: we never
     claim ownership of state we didn't set, and unlock only ever removes
     `inert` from elements this lock actually set. */
  function lockBackground(on) {
    if (!vmnRoot) return;
    if (on) {
      lockedEls = [];
      var node = vmnRoot;
      while (node && node.parentElement && node !== document.body) {
        var parent = node.parentElement;
        Array.prototype.forEach.call(parent.children, function (sib) {
          if (sib === node) return;
          if (!sib.hasAttribute('inert')) {
            sib.setAttribute('inert', '');
            lockedEls.push(sib);
          }
        });
        node = parent;
      }
      if (vmnBar && !vmnBar.hasAttribute('inert')) {
        vmnBar.setAttribute('inert', '');
        lockedEls.push(vmnBar);
      }
    } else {
      lockedEls.forEach(function (el) { el.removeAttribute('inert'); });
      lockedEls = [];
    }
  }

  function openDr() {
    isOpen = true;
    lastFocused = document.activeElement;
    if (dr)  { dr.classList.add('vmn__dr--on');  dr.setAttribute('aria-hidden', 'false'); dr.removeAttribute('inert'); }
    if (ov)  { ov.classList.add('vmn__ov--on');  ov.setAttribute('aria-hidden', 'false'); }
    if (window.valinoScrollLock) window.valinoScrollLock.lock(LOCK_NAME);
    else document.body.style.overflow = 'hidden';
    if (ham) ham.setAttribute('aria-expanded', 'true');
    lockBackground(true);
    if (drx) drx.focus();
  }
  function closeDr() {
    isOpen = false;
    if (dr)  { dr.classList.remove('vmn__dr--on');  dr.setAttribute('aria-hidden', 'true'); dr.setAttribute('inert', ''); }
    if (ov)  { ov.classList.remove('vmn__ov--on');  ov.setAttribute('aria-hidden', 'true'); }
    if (window.valinoScrollLock) window.valinoScrollLock.unlock(LOCK_NAME);
    else document.body.style.overflow = '';
    if (ham) ham.setAttribute('aria-expanded', 'false');
    lockBackground(false);
    /* The trigger that opened the drawer may now be hidden (e.g. the
       hamburger disappears once a breakpoint change reveals the desktop
       nav) — never focus a hidden/inert element. Fall back to the logo,
       which is visible at every breakpoint. */
    var focusTarget = isVisible(lastFocused) ? lastFocused : document.querySelector('.vmn__logo');
    if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus();
    lastFocused = null;
    /* The predictive-search popup (a separate IIFE below) is not inside the
       drawer subtree, so it does not get cleaned up by anything above. Every
       path that closes the drawer — the close button, overlay click, Escape,
       and the desktop-breakpoint handler below — funnels through this one
       function, so dispatching here is the single place needed to keep the
       popup's lifetime tied to the drawer's, without giving the popup code
       its own copy of "is the drawer open" logic to keep in sync. */
    document.dispatchEvent(new CustomEvent('valino:drawer-closed'));
  }

  /* ── cleanup when the viewport crosses the desktop breakpoint while open ──
     Resizing (or rotating) past 1366px hides the drawer/overlay purely via
     CSS; without this, aria-expanded, body scroll lock and the inert
     background all stayed stuck in their "open" state (P1 from review 002). */
  function handleBreakpointChange(e) {
    if (e.matches && isOpen) closeDr();
  }

  /* ── Tab/Shift+Tab wrap inside the open drawer ──
     Uses the same tabindex="-1" signal setPanelTabbable() maintains on
     collapsed accordion content, so the wrap boundary always matches
     whatever the native tab order actually visits — a wrap can never land
     on a link the user can't see. */
  function drawerFocusables() {
    if (!dr) return [];
    var nodes = dr.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]');
    return Array.prototype.filter.call(nodes, function (el) {
      return el.getAttribute('tabindex') !== '-1';
    });
  }
  function handleDrawerTab(e) {
    if (!isOpen || e.key !== 'Tab' || !dr) return;
    var list = drawerFocusables();
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    var active = document.activeElement;
    if (e.shiftKey) {
      if (active === first || !dr.contains(active)) { e.preventDefault(); last.focus(); }
    } else {
      if (active === last || !dr.contains(active)) { e.preventDefault(); first.focus(); }
    }
  }

  function initMegaNav() {
    ham  = document.getElementById('vmn-ham');
    dr   = document.getElementById('vmn-dr');
    ov   = document.getElementById('vmn-ov');
    drx  = document.getElementById('vmn-drx');
    vmnRoot = document.getElementById('vmn');
    vmnBar = vmnRoot ? vmnRoot.querySelector('.vmn__bar') : null;
    if (!vmnRoot || vmnRoot.dataset.vmnBound === '1') return;
    vmnRoot.dataset.vmnBound = '1';
    isOpen = false;
    lastFocused = null;
    lockedEls = [];

    if (ham) ham.addEventListener('click', openDr);
    if (drx) drx.addEventListener('click', closeDr);
    if (ov)  ov.addEventListener('click', closeDr);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) closeDr(); });
    document.addEventListener('keydown', handleDrawerTab);

    var desktopMql = window.matchMedia(DESKTOP_MQ);
    if (desktopMql.addEventListener) desktopMql.addEventListener('change', handleBreakpointChange);
    else if (desktopMql.addListener) desktopMql.addListener(handleBreakpointChange); /* Safari <14 */

    /* Auto-close drawer when the user taps any link inside it. The accordion
       <button> elements (data-vmn-acc) intentionally stay open so we exclude them. */
    if (dr) {
      dr.addEventListener('click', function (e) {
        var a = e.target.closest('a[href]');
        if (a) closeDr();
      });
    }

    /* ── smooth accordion panels ──
       A collapsed panel (max-height:0; overflow:hidden) still lays out its
       children — it does not become display:none — so without this,
       Tab visits its links while they are visually clipped and invisible.
       tabindex="-1" while collapsed removes them from the native tab order
       (and from drawerFocusables()'s boundary calculation below) without
       touching the panel's own open/close animation. */
    var accs = vmnRoot.querySelectorAll('[data-vmn-acc]');
    function setPanelTabbable(panel, tabbable) {
      var focusables = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])');
      Array.prototype.forEach.call(focusables, function (el) {
        if (tabbable) el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', '-1');
      });
    }
    accs.forEach(function (btn) {
      var panel = btn.nextElementSibling;
      if (!panel) return;
      setPanelTabbable(panel, false); // start collapsed => not tabbable
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        /* collapse all siblings first */
        accs.forEach(function (b) {
          if (b !== btn) {
            b.setAttribute('aria-expanded', 'false');
            var p = b.nextElementSibling;
            if (p) { p.style.maxHeight = null; setPanelTabbable(p, false); }
          }
        });
        if (expanded) {
          btn.setAttribute('aria-expanded', 'false');
          panel.style.maxHeight = null;
          setPanelTabbable(panel, false);
        } else {
          btn.setAttribute('aria-expanded', 'true');
          panel.style.maxHeight = panel.scrollHeight + 'px';
          setPanelTabbable(panel, true);
        }
      });
    });

    /* ── click-to-open mega panels (touch / hybrid laptops) ──
       CSS opens the mega on :hover and :focus-within. Touch devices
       have neither, so without JS, tapping a category like "Women"
       jumps straight to /collections/.. and the user never sees the
       mega panel. Pattern: first tap opens (preventDefault), second
       tap navigates. Mouse and keyboard users are unaffected because
       :hover or :focus-within already revealed the panel by click time. */
    var megaItems = vmnRoot.querySelectorAll('.vmn__item--has-mega');
    function closeAllMegas() {
      megaItems.forEach(function (i) { i.classList.remove('vmn__item--open'); });
    }
    /* ── explicit Escape-dismissal, separate from --open ──
       --open is the touch/hybrid tap-to-reveal flag; --dismissed is the
       "the user just asked this panel to close" flag that overrides live
       :hover/:focus-within. Kept apart so dismissing one doesn't fight the
       other's own bookkeeping. undismiss() runs on any interaction that
       plausibly means "the user wants this panel again" — leaving the item
       (focusout past its boundary), a fresh mouse entry, or the ArrowDown
       "open" keyboard gesture on the trigger — so dismissal is never
       permanent (brief 002R3 NAV-02: "don't introduce a permanently closed
       panel"). */
    function dismissItem(item) { item.classList.add('vmn__item--dismissed'); }
    function undismissItem(item) { item.classList.remove('vmn__item--dismissed'); }
    megaItems.forEach(function (item) {
      var link = item.querySelector('.vmn__link');
      if (!link) return;
      link.addEventListener('click', function (e) {
        /* Hover- or keyboard-revealed: let the click navigate normally. */
        if (item.matches(':hover, :focus-within')) return;
        /* Already open from a prior tap: second tap navigates. */
        if (item.classList.contains('vmn__item--open')) return;
        /* First tap on a closed mega: open it instead of navigating. */
        e.preventDefault();
        closeAllMegas();
        item.classList.add('vmn__item--open');
      });
      item.addEventListener('mouseenter', function () { undismissItem(item); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) undismissItem(item);
      });
      link.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { undismissItem(item); }
      });
    });
    /* Tap outside any mega item closes all open panels. */
    document.addEventListener('click', function (e) {
      if (e.target.closest('.vmn__item--has-mega')) return;
      closeAllMegas();
    });
    /* Escape visually dismisses an open desktop mega panel and returns focus
       to its trigger. Desktop panels can be open purely via CSS
       :focus-within (keyboard user tabbed into a submenu link); the trigger
       focus() below is itself still a descendant of .vmn__item, so
       :focus-within stays true after this runs — closeAllMegas() alone only
       strips the JS `--open` class and cannot override that CSS rule, which
       is why dismissItem() (backed by the !important CSS above) exists as a
       separate, higher-precedence signal (brief 002R3 NAV-02). */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var active = document.activeElement;
      var openItem = active && active.closest ? active.closest('.vmn__item--has-mega') : null;
      if (openItem) {
        dismissItem(openItem);
        var trigger = openItem.querySelector('.vmn__link');
        if (trigger) trigger.focus();
      }
      closeAllMegas();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaNav);
  } else {
    initMegaNav();
  }

  /* Shopify theme-editor section reload: the section's DOM is replaced
     wholesale, so re-bind against the fresh nodes. `shopify:section:load`
     fires on `document` with `event.target` set to the reloaded section's
     wrapper — this JS bundle tag can't read per-instance Liquid variables,
     so we identify "our" section by looking for #vmn inside it rather than
     comparing section ids. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#vmn')) {
      initMegaNav();
    }
  });
  /* If the section is torn down (or another instance swapped in) while the
     drawer is open, release the scroll lock/inert state instead of leaking
     it onto whatever renders next. */
  document.addEventListener('shopify:section:unload', function (e) {
    if (isOpen && e.target && e.target.querySelector && e.target.querySelector('#vmn')) {
      if (window.valinoScrollLock) window.valinoScrollLock.unlock(LOCK_NAME);
      lockBackground(false);
      isOpen = false;
    }
  });
})();

/* ── Smart Predictive Search ──────────────────────────────── */
(function () {
  /* Synonym map: user shorthand → Shopify query term
     Works for any product added now or in the future. */
  var SYN = {
    'tshirt':'t-shirt','t shirt':'t-shirt',
    'sneaker':'sneakers','tennis shoes':'sneakers','tennis':'sneakers',
    'handbag':'handbags','purse':'handbags','purses':'handbags',
    'jacket':'jackets','coat':'coats',
    'pant':'pants','trouser':'pants','trousers':'pants',
    'jean':'jeans','denim':'jeans',
    'shoe':'shoes',
    'bag':'bags',
    'ring':'jewelry','necklace':'jewelry','bracelet':'jewelry',
    'earring':'earrings',
    'watch':'watches',
    'skirt':'skirts',
    'blouse':'blouses',
    'short':'shorts',
    'swimsuit':'swimwear','bikini':'swimwear',
    'legging':'leggings',
    'hoodie':'hoodies',
    'sweater':'sweaters','jumper':'sweaters',
    'backpack':'backpacks',
    'wallet':'wallets',
    'sunglass':'sunglasses','shades':'sunglasses',
    'hat':'hats','cap':'hats','caps':'hats',
    'belt':'belts',
    'scarf':'scarves',
    'perfume':'fragrance','cologne':'fragrance',
    'moisturizer':'skincare','lotion':'skincare',
    'lipstick':'makeup','foundation':'makeup','mascara':'makeup',
    'earphone':'earphones','earbud':'earbuds',
    'headphone':'headphones',
    'kids':'children','toddler':'baby','babies':'baby',
    'men':"men's",'women':"women's",'ladies':"women's",
    'girl':'girls','boy':'boys',
    'sport':'sports','gym':'activewear','active':'activewear',
    'light':'led','lamp':'led light'
  };

  function expand(q) {
    var k = q.toLowerCase().trim();
    return SYN[k] || q;
  }

  function money(p) {
    var n = parseFloat(p);
    if (isNaN(n)) return '';
    return '$' + (Number.isInteger(n) ? n : n.toFixed(2));
  }

  /* This renderer builds markup as strings and assigns it via innerHTML, so
     every value that did not originate as a literal in this file (the typed
     query, and title/url text from the suggest.json response) must be
     escaped before insertion. Escaping the five HTML-significant characters
     is safe for both text-node and double-quoted-attribute contexts, so one
     helper covers everywhere this renderer touches API/user text. */
  function escText(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* The javascript tag this file uses does not render Liquid, so
     routes.all_products_collection_url is exposed via a data attribute on
     #vmn (see the section markup) instead of being interpolated here. */
  function allProductsUrl() {
    var vmn = document.getElementById('vmn');
    return (vmn && vmn.getAttribute('data-all-products-url')) || '/collections/all';
  }

  function noResultsBrowseLabel() {
    var vmn = document.getElementById('vmn');
    return (vmn && vmn.getAttribute('data-no-results-browse-label')) || 'Browse all products';
  }

  /* Single dropdown, appended inside #vmn (the mega-nav root) rather than
     document.body. #vmn has no transform/overflow of its own (only its
     .vmn__dr descendant is transformed+clipped, and #vmn-ov/#vmn-dr sit
     alongside it), so position:fixed math and full-viewport visibility are
     unchanged from a body-attached node — but #vmn is also the exact root
     the drawer's background-inert lock (see the sibling IIFE above) walks
     UP FROM and never inerts. A body-attached sibling was getting caught by
     that walk and marked inert, which is what made suggestions unclickable
     under the mobile drawer (SEARCH-01 finding: hit-testing reached the
     underlying menu strip instead of the suggestion). */
  var drop = document.createElement('div');
  drop.className = 'vsps';
  drop.setAttribute('aria-live', 'polite');
  (document.getElementById('vmn') || document.body).appendChild(drop);

  var activeInput = null;
  var ctrl = null;  /* AbortController for in-flight fetch */
  var timer = null;
  var pendingInput = null; /* owner of the debounced request, before show() */
  var gen = 0;      /* bumped whenever pending/in-flight work becomes stale */

  function pos(inp) {
    var r = inp.getBoundingClientRect();
    var w = Math.max(r.width, 300);
    var left = r.left;
    /* prevent right-edge overflow */
    if (left + w > window.innerWidth - 10) left = window.innerWidth - w - 10;
    var top = r.bottom + 6;
    var margin = 10;
    /* Base height on actual available space below the input, not an
       unconditional minimum — a fixed floor pushed the popup's bottom edge
       past the viewport on short screens (SEARCH-01 R3 finding). The .vsps
       rule below has overflow-y:auto, so a small max-height still keeps
       every result reachable by scrolling. */
    drop.style.top       = top + 'px';
    drop.style.left      = left + 'px';
    drop.style.width     = w + 'px';
    drop.style.maxHeight = Math.max(window.innerHeight - top - margin, 0) + 'px';
  }

  function clearInputAriaState(inp) {
    if (!inp) return;
    inp.setAttribute('aria-expanded', 'false');
    inp.removeAttribute('aria-activedescendant');
  }

  function show(inp) {
    /* Switching which input owns the popup (desktop <-> drawer) must not
       leave the previous input's aria-expanded/aria-activedescendant stale. */
    if (activeInput && activeInput !== inp) clearInputAriaState(activeInput);
    activeInput = inp;
    pos(inp);
    drop.classList.add('vsps--on');
    inp.setAttribute('aria-expanded', 'true');
  }
  function hide() {
    /* Invalidate anything pending/in-flight so it can never render after
       this point — a queued debounce timer is cancelled outright, and any
       fetch already past the point where abort() has an effect is caught by
       the generation check in search()'s .then()/.catch(). */
    gen++;
    clearTimeout(timer);
    timer = null;
    pendingInput = null;
    if (ctrl) { ctrl.abort(); ctrl = null; }
    clearInputAriaState(activeInput);
    drop.classList.remove('vsps--on');
    drop.innerHTML = '';
    activeInput = null;
  }

  function render(q, prods, colls) {
    var h = '';
    /* Unique ids + role="option" + tabindex="-1" on every suggestion:
       - id/role let the input's aria-activedescendant name the highlighted
         option (WAVE 1 STEP 8 in valino-enhancements.js), matching the
         listbox role already set on this same drop element.
       - tabindex="-1" intentionally keeps these real <a> links out of the
         native Tab order (arrow keys + Enter are the supported keyboard
         path here, per the combobox/listbox pattern), so Tab from either
         search input behaves predictably instead of Tab-ing through
         however many suggestions happen to render. Pointer/click activation
         is unaffected by tabindex. */
    var optIndex = 0;
    function optAttrs() { return ' id="vsps-opt-' + (optIndex++) + '" role="option" tabindex="-1"'; }
    if (colls.length) {
      h += '<div class="vsps__head">Categories</div>';
      colls.forEach(function(c) {
        h += '<a href="'+escText(c.url)+'" class="vsps__item"'+optAttrs()+'>'
           + '<div class="vsps__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(225,29,48,0.8)" stroke-width="2" stroke-linecap="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg></div>'
           + '<div class="vsps__info"><div class="vsps__name">'+escText(c.title)+'</div></div>'
           + '</a>';
      });
    }
    if (prods.length) {
      h += '<div class="vsps__head">Products</div>';
      var fallbackSvg = "data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Crect%20width%3D%2240%22%20height%3D%2240%22%20fill%3D%22%23222%22%2F%3E%3Cpath%20d%3D%22M12%2014h16v12H12z%22%20fill%3D%22none%22%20stroke%3D%22%23555%22%20stroke-width%3D%221.4%22%2F%3E%3Ccircle%20cx%3D%2217%22%20cy%3D%2218%22%20r%3D%221.4%22%20fill%3D%22%23555%22%2F%3E%3Cpath%20d%3D%22M13%2025l5-5%203%203%203-2%204%204%22%20fill%3D%22none%22%20stroke%3D%22%23555%22%20stroke-width%3D%221.4%22%2F%3E%3C%2Fsvg%3E";
      prods.forEach(function(p) {
        /* Build best-available image URL: featured_image -> image -> first variant image */
        var imgSrc = '';
        if (p.featured_image) imgSrc = (typeof p.featured_image === 'string') ? p.featured_image : (p.featured_image.url || p.featured_image.src || '');
        if (!imgSrc && p.image) imgSrc = (typeof p.image === 'string') ? p.image : (p.image.url || p.image.src || '');
        if (!imgSrc && p.images && p.images.length) imgSrc = (typeof p.images[0] === 'string') ? p.images[0] : (p.images[0].url || p.images[0].src || '');
        /* Normalize Shopify CDN size param + protocol */
        if (imgSrc) {
          if (imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
          imgSrc = imgSrc.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master)\./, '_120x120.');
        }
        var img = imgSrc
          ? '<img src="'+escText(imgSrc)+'" class="vsps__img" alt="" loading="lazy" decoding="async" onerror="this.onerror=null;this.src=\''+fallbackSvg+'\';">'
          : '<img src="'+fallbackSvg+'" class="vsps__img" alt="" loading="lazy" decoding="async">';
        var pr = p.price ? '<div class="vsps__price">'+money(p.price)+'</div>' : '';
        h += '<a href="'+escText(p.url)+'" class="vsps__item"'+optAttrs()+'>'+img
           + '<div class="vsps__info"><div class="vsps__name">'+escText(p.title)+'</div>'+pr+'</div>'
           + '</a>';
      });
    }
    if (!h) {
      var browseId = 'vsps-opt-' + (optIndex++);
      drop.innerHTML = '<div class="vsps__status">No results for \u201c'+escText(q)+'\u201d</div>'
        + '<a href="'+ escText(allProductsUrl()) +'" class="vsps__all" id="'+browseId+'" role="option" tabindex="-1">'+escText(noResultsBrowseLabel())+' \u2192</a>';
      return;
    }
    h += '<a href="/search?type=product&q='+encodeURIComponent(q)+'" class="vsps__all"'+optAttrs()+'>See all results for \u201c'+escText(q)+'\u201d \u2192</a>';
    drop.innerHTML = h;
  }

  function search(inp, q) {
    if (!q || q.length < 2) { hide(); return; }
    /* This call owns a fresh generation: any earlier in-flight/queued work
       (including one already past the point where abort() can stop it) is
       recognized as stale by comparing myGen against the shared gen counter
       when the response actually arrives, not just at abort time. */
    var myGen = ++gen;
    show(inp);
    /* New markup is about to replace whatever options aria-activedescendant
       might still be naming from the previous result set. */
    inp.removeAttribute('aria-activedescendant');
    drop.innerHTML = '<div class="vsps__status">Searching\u2026</div>';
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    var myCtrl = ctrl;
    fetch('/search/suggest.json?q='+encodeURIComponent(expand(q))
        + '&resources[type]=product,collection&resources[limit]=6',
        { signal: myCtrl.signal })
      .then(function(r){ return r.json(); })
      .then(function(d){
        if (myGen !== gen || inp !== activeInput) return; /* stale response or owner switched */
        var res   = (d.resources && d.resources.results) || {};
        var prods = res.products    || [];
        var colls = res.collections || [];
        render(q, prods, colls);
      })
      .catch(function(e){
        if (e.name === 'AbortError') return;
        if (myGen === gen) hide();
      });
  }

  function attach(inp) {
    if (!inp) return;
    inp.addEventListener('input', function(){
      /* A keystroke invalidates anything scheduled/in-flight before it \u2014
         not just the next search() call \u2014 so a still-resolving response
         for a previous query (e.g. "shoe") can never render once the input
         already says something else (e.g. "watch"), even mid-debounce. */
      clearTimeout(timer);
      gen++;
      if (ctrl) { ctrl.abort(); ctrl = null; }
      /* Don't wait for the eventual search()/render() call to clear this —
         the option it names is already stale the instant the query changes. */
      inp.removeAttribute('aria-activedescendant');
      var q = inp.value.trim();
      if (!q || q.length < 2) { hide(); return; }
      pendingInput = inp;
      timer = setTimeout(function(){
        timer = null;
        pendingInput = null;
        search(inp, q);
      }, 280);
    });
    inp.addEventListener('focus', function(){
      if (inp.value.trim().length >= 2) search(inp, inp.value.trim());
    });
    inp.addEventListener('keydown', function(e){
      if (e.key === 'Escape') { hide(); inp.blur(); }
    });
  }

  /* Attach predictive search to the trust-bar search (only desktop search now) and mobile drawer search */
  attach(document.querySelector('.valino-trust-bar__search-input'));
  attach(document.querySelector('.vmn__dr-sf2 input'));

  /* Hide on outside click */
  document.addEventListener('click', function(e){
    if (!drop.contains(e.target) && e.target !== activeInput) hide();
  });

  /* Close/reset the popup whenever the mobile drawer closes — by any path
     (close button, overlay click, Escape, or crossing the desktop
     breakpoint while open) — so it can never be left open/expanded floating
     over a now-hidden drawer, or reopen from a stale queued search once the
     drawer's input is inert again. A no-op when the desktop trust-bar input
     currently owns the popup. */
  document.addEventListener('valino:drawer-closed', function(){
    var drawerOwnsActive = activeInput && activeInput.closest('.vmn__dr-sf2');
    var drawerOwnsPending = pendingInput && pendingInput.closest('.vmn__dr-sf2');
    if (drawerOwnsActive || drawerOwnsPending) hide();
  });

  /* Hide on scroll (nav is sticky so inputs don't move, but closing is clean UX) */
  window.addEventListener('scroll', function(){ if (activeInput) hide(); }, { passive: true });

  /* Reposition on resize */
  window.addEventListener('resize', function(){ if (activeInput) pos(activeInput); });

  /* Close dropdown when user clicks a result and navigates */
  drop.addEventListener('click', function(){ hide(); });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valino-recently-viewed"] && !Shopify.designMode) return;
  try {
    
(function () {
  var KEY = 'valino_recent_v1';
  var MAX = 20;
  var section = document.getElementById('vrv-section');
  var track = document.getElementById('vrv-track');
  var clearBtn = document.getElementById('vrv-clear');
  if (!section || !track) return;

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h.length > 0; }).slice(0, MAX) : [];
    }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }
  function push(handle) {
    if (!handle) return;
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    write(list);
  }

  var current = section.getAttribute('data-current');
  if (current) push(current);

  var limit = parseInt(section.getAttribute('data-limit'), 10) || 10;
  var handles = read().filter(function (h) { return h !== current; }).slice(0, limit);
  if (!handles.length) return;

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return {'&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'}[c];
    });
  }
  function safeUrl(value) {
    try {
      var url = new URL(value, location.origin);
      return /^https?:$/.test(url.protocol) ? url.href : '';
    } catch (e) { return ''; }
  }
  var formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: section.getAttribute('data-currency') || 'USD'
  });
  function money(cents) {
    var n = Number(cents);
    return Number.isFinite(n) ? formatter.format(n / 100) : '';
  }
  function card(p) {
    if (!p) return '';
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && typeof img !== 'string') img = img.src || img.url || '';
    img = img ? safeUrl(img) : '';
    if (img) img = img.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master)\./, '_360x450.');
    var price = p.price || (p.variants && p.variants[0] && p.variants[0].price) || 0;
    var cmp   = p.compare_at_price || (p.variants && p.variants[0] && p.variants[0].compare_at_price) || 0;
    var cmpTag = (cmp && parseFloat(cmp) > parseFloat(price))
      ? '<span class="vrv__price-compare">' + money(cmp) + '</span>' : '';
    var imgTag = img
      ? '<img class="vrv__img" src="' + esc(img) + '" alt="" loading="lazy" width="360" height="450">'
      : '<div class="vrv__img" style="background:#f0f0f0"></div>';
    return '<a href="' + esc(safeUrl(p.url)) + '" class="vrv__card">'
         + '<div class="vrv__img-wrap">' + imgTag + '</div>'
         + '<div class="vrv__info"><p class="vrv__name">' + esc(p.title || '') + '</p>'
         + '<div><span class="vrv__price">' + (p.price_varies ? 'From ' : '') + money(price) + '</span>' + cmpTag + '</div>'
         + '</div></a>';
  }

  Promise.all(handles.map(function (h) {
    return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'products/' + encodeURIComponent(h) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  })).then(function (products) {
    var valid = products.filter(function (p) { return p && p.available !== false; });
    if (!valid.length) return;
    track.innerHTML = valid.map(card).join('');
    section.classList.add('vrv--on');
    clearBtn.hidden = false;
  });

  clearBtn.addEventListener('click', function () {
    write([]);
    track.innerHTML = '';
    section.classList.remove('vrv--on');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valino-related-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  var track = document.getElementById('vrelated-track');
  if (!track) return;
  var section = document.getElementById('vrelated-section');
  var wrap = track.closest('.vrelated__track-wrap');
  var prevBtn = wrap.querySelector('.vrelated__arrow--prev');
  var nextBtn = wrap.querySelector('.vrelated__arrow--next');
  var cardW = function () { var c = track.querySelector('.vrelated__card'); return c ? c.offsetWidth + 16 : 236; };
  if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -cardW() * 2, behavior: 'smooth' }); });
  if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: cardW() * 2, behavior: 'smooth' }); });

  /* Upgrade with Shopify ML recs (intent=related) when available */
  var pid = section && section.getAttribute('data-product-id');
  var lim = (section && section.getAttribute('data-limit')) || 8;
  if (!pid) return;

  function money(cents) {
    var n = parseFloat(cents);
    if (isNaN(n)) return '';
    var d = n / 100;
    return '$' + (Number.isInteger(d) ? d : d.toFixed(2));
  }
  function card(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && typeof img !== 'string') img = img.src || img.url || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    if (img) img = img.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master)\./, '_440x550.');
    var price = p.price || (p.variants && p.variants[0] && p.variants[0].price) || 0;
    var cmp   = p.compare_at_price || (p.variants && p.variants[0] && p.variants[0].compare_at_price) || 0;
    var cmpTag = (cmp && parseFloat(cmp) > parseFloat(price))
      ? '<span class="vrelated__price-compare">' + money(cmp) + '</span>' : '';
    var imgTag = img
      ? '<img class="vrelated__img" src="' + img + '" alt="" loading="lazy" width="440" height="550">'
      : '<div class="vrelated__img" style="background:#f0f0f0"></div>';
    return '<a href="' + p.url + '" class="vrelated__card">'
         + '<div class="vrelated__img-wrap">' + imgTag + '</div>'
         + '<div class="vrelated__info"><p class="vrelated__name">' + (p.title || '') + '</p>'
         + '<div><span class="vrelated__price">' + money(price) + '</span>' + cmpTag + '</div>'
         + '</div></a>';
  }
  function load(intent) {
    return fetch('/recommendations/products.json?product_id=' + encodeURIComponent(pid)
               + '&limit=' + encodeURIComponent(lim) + '&intent=' + intent)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { return (d && d.products) ? d.products : []; })
      .catch(function () { return []; });
  }
  load('related').then(function (list) {
    if (list && list.length >= 4) {
      track.innerHTML = list.map(card).join('');
      return;
    }
    return load('complementary').then(function (list2) {
      if (list2 && list2.length >= 4) track.innerHTML = list2.map(card).join('');
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
